import { render, staticRenderFns } from "./taskListDialog.vue?vue&type=template&id=ad5b2404&scoped=true"
import script from "./taskListDialog.vue?vue&type=script&lang=js"
export * from "./taskListDialog.vue?vue&type=script&lang=js"
import style0 from "./taskListDialog.vue?vue&type=style&index=0&id=ad5b2404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5b2404",
  null
  
)

export default component.exports